import { render, staticRenderFns } from "./MonitoringSCMDashboard.vue?vue&type=template&id=495c1706&"
import script from "./MonitoringSCMDashboard.vue?vue&type=script&lang=js&"
export * from "./MonitoringSCMDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports